import './temoignages.scss';
import { Splide } from '@splidejs/splide';

(($) => {
    function initTemoignagesSlider() {

        let temoignages = new Splide( '.section-temoignages .splide', {
            type   : 'loop',
            gap : 30,
            autoWidth: true,
            perMove: 1,
    
            breakpoints: {
                1279: {
                    focus  : 'center',
                },
                767: {
                    gap: 10,
                }
            }
        });
        
        temoignages.mount()

    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initTemoignagesSlider", initTemoignagesSlider);
    } else {
        $(document).ready(initTemoignagesSlider);
    }
})(jQuery);